import { Link } from "react-router-dom";
import { Mountain, ChevronRight, MapPin } from "lucide-react";
import Seo from "../components/Seo";
import { SITE_URL, BUSINESS, LEGAL } from "../lib/site";
import { LEGAL_PAGES } from "../data/legalPages";

export default function LegalPage({ slug }) {
  const page = LEGAL_PAGES[slug];
  if (!page) return null;

  return (
    <div className="bg-ivory min-h-screen">
      <Seo title={page.title} description={page.description} path={`/${slug}`} />

      <nav className="flex items-center justify-between px-6 md:px-12 py-5 bg-fir text-ivory">
        <Link to="/" className="flex items-center gap-2"><Mountain className="text-gold" size={24} /><span className="font-display text-xl">Appartamenti in Val di Sole</span></Link>
        <Link to="/#strutture" className="gold-btn px-4 py-2 rounded-xl text-sm">Verifica disponibilità</Link>
      </nav>

      <div className="max-w-3xl mx-auto px-6 pt-8 text-sm text-fir-deep/60 flex items-center gap-1">
        <Link to="/" className="hover:text-gold">Home</Link><ChevronRight size={14} /><span className="text-fir-deep/80">{page.title}</span>
      </div>

      <article className="max-w-3xl mx-auto px-6 py-8" data-testid={`legal-${slug}`}>
        <h1 className="font-display text-4xl md:text-5xl text-fir mb-2">{page.title}</h1>
        <p className="text-fir-deep/50 text-sm mb-10">Ultimo aggiornamento: {LEGAL.updated}</p>

        <div className="space-y-9">
          {page.sections.map((s, i) => (
            <section key={i}>
              <h2 className="font-display text-2xl text-fir mb-3">{s.h2}</h2>
              {(s.p || []).map((para, j) => (
                <p key={j} className="text-fir-deep/80 leading-relaxed mb-2">{para}</p>
              ))}
              {s.list && (
                <ul className="list-disc pl-5 space-y-1.5 text-fir-deep/80 mt-2">
                  {s.list.map((li, k) => <li key={k}>{li}</li>)}
                </ul>
              )}
              {s.p2 && <p className="text-fir-deep/80 leading-relaxed mt-3">{s.p2}</p>}
            </section>
          ))}
        </div>

        <div className="mt-12 flex gap-4 text-sm">
          <Link to="/privacy" className="text-fir hover:text-gold">Informativa Privacy</Link>
          <Link to="/cookie-policy" className="text-fir hover:text-gold">Cookie Policy</Link>
        </div>
      </article>

      <footer className="bg-fir-deep text-ivory px-6 py-10">
        <div className="max-w-6xl mx-auto flex flex-wrap items-center justify-between gap-4">
          <div className="flex items-center gap-2"><Mountain className="text-gold" size={24} /><span className="font-display text-2xl">Appartamenti in Val di Sole</span></div>
          <div className="text-ivory/60 text-sm flex items-center gap-2"><MapPin size={15} className="text-gold" /> {BUSINESS.locality}, Val di Sole (TN) · {BUSINESS.phone}</div>
          <span className="text-ivory/40 text-sm">© {new Date().getFullYear()} Appartamenti in Val di Sole</span>
        </div>
      </footer>
    </div>
  );
}
